import React from "react";

import Hero from "./Hero";
import CreateTicket from "./CreateTicket";


function PricingPage() {
  return (
    <>
      <Hero />
      <CreateTicket />
    </>
  );
}

export default PricingPage;